module.exports = __webpack_public_path__ + "static/media/wifi-close.7f6fd433.png";